import { INVITATION_STATUS } from 'utils/Invitation';

export const ENABLE_ALL_ASSETS = { YES: 'YES', NO: 'NO' };

export const STATUS = {
  ACCEPTED: INVITATION_STATUS.ACCEPTED,
  REJECTED: INVITATION_STATUS.REJECTED,
};
